module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-minus-0e0b089d.svg";